import { menuStructureType } from "../models/teams.model";

export const ROLE_LIST: { id: number; name: string }[] = [
    { id: 1, name: 'Manager Team' },
    { id: 2, name: 'Operation Team' },
    { id: 3, name: 'Finance Team' },
    { id: 4, name: 'Technology Team' },
    { id: 5, name: 'Customer Service Team' },
  ];

